import { TotalizersGrid } from "@/modules/common/components";
import { AdminManagementCompaniesTotalizersResponse } from "@/service/response/admin-management-companies";
import { Building2Icon, CheckCircle2, Factory, Network } from "lucide-react";

interface ManagerTotalizersParams {
  data?: AdminManagementCompaniesTotalizersResponse;
  isLoading?: boolean;
  className?: string;
}

const ManagerTotalizers = ({ data, isLoading = false, className }: ManagerTotalizersParams) => (
  <TotalizersGrid
    className={className}
    isLoading={isLoading}
    items={[
      {
        key: "total-managers",
        title: "Total Gestoras",
        value: data?.totalManagers,
        icon: <Building2Icon className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "third-party-management",
        title: "Gestão de Terceiros",
        value: data?.thirdPartyManagement,
        icon: <Network className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "own-management",
        title: "Gestão Própria",
        value: data?.ownManagement,
        icon: <Factory className="w-5 h-5 text-green-700 font-bold" />,
        iconWrapperClassName: "bg-emerald-200/20",
      },
      {
        key: "active",
        title: "Ativos",
        value: data?.active,
        icon: <CheckCircle2 className="w-5 h-5 text-green-500 font-bold" />,
        iconWrapperClassName: "bg-emerald-100",
      },
    ]}
  />
);

export default ManagerTotalizers;
